const tmpWorldScale = new THREE.Vector3(1, 1, 1);
const tmpWorldCenter = new THREE.Vector3();
const tmpBox = new THREE.Box3();
const tmpDir = new THREE.Vector3();
const tmpAxis = new THREE.Vector3();
const tmpInverse = new THREE.Matrix4();


function createAssemble({ framerate, delay, duration, object, assembleDist, assembleDir }) {
    delay = 0;
    // delay = Q3.editMode ? 0 : delay;

    const delayOffset = Math.max(0, delay);
    const tracks = [];
    const stepCount = framerate * duration;
    const timeStepSize = duration / stepCount;
    const valueStepSize = 1 / stepCount;

    tmpBox.setFromObject(object).getCenter(tmpWorldCenter);

    object.traverse(object => {
        if (!object.isMesh) return;

        const times = [], values = [];
        tmpWorldScale.setFromMatrixScale(object.parent.matrixWorld);

        switch (assembleDir) {
            case "center":
                tmpInverse.getInverse(object.parent.matrixWorld);
                tmpBox
                    .setFromObject(object)
                    .getCenter(tmpDir)
                    .sub(tmpWorldCenter)
                    .applyMatrix4(tmpInverse)
                    .normalize();
                break;
            case "random":
                tmpDir
                    .set(1 - 2 * Math.random(), 1 - 2 * Math.random(), 1 - 2 * Math.random())
                    .normalize();
                break;
        }

        const animData = Q3.SlideManager.currentSlide.animation[object.uuid];
        const { x: px, y: py, z: pz } = animData
            ? Q3.SlideManager.currentSlide.animation[object.uuid].position
            : object.position;
        const opos = new THREE.Vector3(px, py, pz);

        if (delay > 0) {
            const assembleStepCount = framerate * delay;
            const timeStepSize = delay / (assembleStepCount - 0);
            const y = valueStepSize * (stepCount - 0);

            for (let i = 0; i < assembleStepCount; i++) {
                const x = i * timeStepSize;

                tmpAxis
                    .copy(tmpDir)
                    .divide(tmpWorldScale)
                    .multiplyScalar(y)
                    .multiplyScalar(assembleDist)
                    .add(opos);

                times.push(x);
                values.push(...tmpAxis.toArray());
            }
        }

        for (let i = 0; i < stepCount; i++) {
            const x = i * timeStepSize + delayOffset;
            const y = valueStepSize * (stepCount - i);

            tmpAxis
                .copy(tmpDir)
                .divide(tmpWorldScale)
                .multiplyScalar(y)
                .multiplyScalar(assembleDist)
                .add(opos);

            times.push(x);
            values.push(...tmpAxis.toArray());
        }

        times.push(duration + delayOffset);
        values.push(...opos.toArray());

        const kfPosition = new THREE.VectorKeyframeTrack(`${object.uuid}.position`, times, values);

        tracks.push(kfPosition);
    });

    const clip = new THREE.AnimationClip(THREE.Math.generateUUID(), undefined, tracks);

    return clip;
}

export default createAssemble;
export { createAssemble };